import * as React from "react";
import { Popup } from "@progress/kendo-react-popup";
export const CustomStartDatePickerPopUp = (props) => {
  return (
    <Popup
      {...props}
      anchorAlign={{
        horizontal: "right",
        vertical: "right",
      }}
      popupAlign={{
        horizontal: "left",
        vertical: "center",
      }}
    />
  );
};